import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MessageService } from 'src/app/utility/services/message/message.service';
import { FileHandlerService, IFileOptions } from 'src/app/utility/services/file-handler/file-handler.service';
import { FileValidatorService } from '../../service/file-validator/file-validator.service';
import { IFileExtend } from '../../model/IFileExtend';
import { ValidatingEnroleeMessage } from 'src/app/utility/services/message/custom-messages';
import { PPORequestStatus, ValidatorType } from 'src/app/utility/enum/global-enum';
import { GroupClaimSubmissionService } from '../../service/group-claim-submission/group-claim-submission.service';
import { NavigateService } from 'src/app/utility/services/navigate/navigate.service';
import { PpoListService } from '../../service/ppo-list/ppo-list.service';



@Component({
  selector: 'app-online-document-upload-ppo',
  templateUrl: './online-document-upload-ppo.component.html',
  styleUrls: ['./online-document-upload-ppo.component.scss']
})
export class OnlineDocumentUploadPpoComponent implements OnInit {

  //Common Variable
  private browserId: string;
  customMessage = new ValidatingEnroleeMessage();

  isDocSubmission: boolean;
  isDownloadPPOClaimForm: boolean;
  isDownloadPPOBalanceSummary: boolean;
  isManualSubmission: boolean;

  fileExtends: IFileExtend[];
  fileExtend: IFileExtend;
  fileOption: IFileOptions = { acctptedTypes: "" };

  claimFormFile: any;
  statusId: PPORequestStatus;

  //Online GM Group Claim Submission variable
  ppoRequestId: number;
  productId: number;
  productName: string;
  enrolId: number;
  enrolDependentId: number;
  claimAmount: number;
  insuranceAmount: number;
  claimForm: IFileExtend;
  balanceSummary: IFileExtend;
  claimEntryId: number;
  benefitTotalNetAmount: number;

  //Input and Output decorator
  @Input() set dataReqiredForClaimSubmissionDocumentUpload(value) {
    if (value) {
      this.ppoRequestId = value.id;
      this.claimEntryId = value.claimEntryId;
      this.productId = value.productId;
      this.productName = value.productName;
      this.enrolId = value.enrolId;
      this.enrolDependentId = value.dependentId;
      this.claimAmount = value.claimAmount;
      this.insuranceAmount = 0;
      this.browserId = value.browserId;

      this.isDocSubmission = true;
      this.isDownloadPPOClaimForm = true;
      this.isDownloadPPOBalanceSummary = true;
      this.isManualSubmission = false;
      this.benefitTotalNetAmount = value.benefitTotalNetAmount;

      this.getPPOClaimFormPdf();
      this.getPPOBalanceSummaryPdf();
      this.getOnlineClaimSubmissionDocuments();
      this.getFileExtension();
    }
  };

  @Output() onBackButtonSubmission = new EventEmitter<any>();

  constructor(
    private groupClaimSubmissionService: GroupClaimSubmissionService,
    private messageService: MessageService,
    private fileHandlerService: FileHandlerService,
    private fileValidatorService: FileValidatorService,
    private navigationService: NavigateService,
    private ppoListService: PpoListService
  ) { }

  ngOnInit() { }

  getFileExtension() {
    this.fileValidatorService
      .getByValidatorType(ValidatorType.GroupClaimSubmission)
      .subscribe(
        res => {
          this.fileOption.validators = res;
        },
        error => {
          this.messageService.show(error.error.message, "error");
        }
      );
  }

  getOnlineClaimSubmissionDocuments() {
    this.fileExtends = [];
    this.groupClaimSubmissionService.getPpoClaimDocuments(this.productId)
      .subscribe(
        (res: any) => {
          res.data.forEach(item => {
            this.fileExtends.unshift({
              documentId: item.documnetTypeID,
              docName: item.documnetTypeName,
              file: null,
              acctptedTypes: "",
              index: 1,
              isOptional: item.isOptional
            });
          });
          this.ascendingOrderByDocumentId();
        },
        error => {
          this.messageService.show(error.error.message, "error");
        }
      );
  }

  onFileChange(event, item: IFileExtend) {
    if (
      event &&
      this.fileHandlerService.validator(event.target.files[0], this.fileOption)
    ) {
      item.file = event.target.files[0];
      this.documentRequiredValidation();
    }
  }

  documentRequiredValidation() {
    //As All documents are mandatory. So check the number of required document and number of uploaded documents
    let rerquiredfile = 0;
    this.fileExtends.forEach(ele => {
      if (!ele.isOptional) {
        rerquiredfile++;
      }
    });
    let uploadedFile = 0;
    this.fileExtends.forEach(x => {
      if (x.file != null && !x.isOptional) {
        uploadedFile++;
      }
    });

    if (rerquiredfile === uploadedFile) {
      this.isDocSubmission = false;
    } else {
      this.isDocSubmission = true;
    }
  }

  addDocument(item: IFileExtend) {
    let indx = 0;
    const obj = this.fileExtends.filter(x => x.documentId === item.documentId);
    obj.forEach(element => {
      if (element.index > indx) {
        indx = element.index;
      }
    });

    this.fileExtends.push({
      documentId: item.documentId,
      docName: item.docName,
      file: null,
      acctptedTypes: "",
      index: indx + 1,
      isOptional: item.isOptional
    });

    this.ascendingOrderByDocumentId();
    this.documentRequiredValidation();
  }

  ascendingOrderByDocumentId() {
    this.fileExtends = this.fileExtends.sort((t1, t2) => {
      if (t1.documentId < t2.documentId) {
        return 1;
      }
      if (t1.documentId > t2.documentId) {
        return -1;
      }
      return 0;
    });
  }

  removeDocument(item: IFileExtend) {
    this.fileExtends = this.fileExtends.filter(x => x !== item);
    this.documentRequiredValidation();
  }

  getClaimSubmissionDocumentData() {
    const entity = {
      enrolId: this.enrolId,
      componentValidatorId: ValidatorType.GroupClaimSubmission,
      browserId: this.browserId,
      enrolDependentId: this.enrolDependentId === 0 ? null : this.enrolDependentId,
      productId: this.productId,
      claimAmount: this.claimAmount,
      insuranceAmount: this.insuranceAmount,
      ppoRequestId: this.ppoRequestId,
      claimEntryId: this.claimEntryId
    };
    const formData = this.getFormData(entity);
    return formData;
  }

  getFormData(data: any): FormData {
    let tempFileExtends = [...this.fileExtends];
    tempFileExtends.push(this.claimForm);
    tempFileExtends.push(this.balanceSummary);

    if (tempFileExtends.length <= 0) {
      tempFileExtends.push(this.fileExtend);
    }
    const formData = new FormData();
    formData.append("model", JSON.stringify(data));
    let additionalId: number = 0;
    tempFileExtends.forEach(x => {
      if (x.index != 0) {
        if (tempFileExtends.filter(f => f.documentId == x.documentId).length > 1)
          additionalId++;
      }
      formData.append(
        x.documentId.toString() + "-" + additionalId.toString(),
        x.file
      )
    });
    return formData;
  }

  submit() {
    this.messageService.confirm('Are you sure you want to submit?', false).then(result => {
      if (result.value) {
        this.statusId = PPORequestStatus.Submitted;
        this.submitOnlineClaimSubmission();
      }
      else {
        this.navigationService.toPpoRequestList();
      }
    })
  }

  cancel() {
    this.messageService.confirm('Are you sure you want to cancel?').then(result => {
      if (result.value) {
        this.isManualSubmission = null;
        this.statusId = PPORequestStatus.Cancelled;
        this.updateSubmissionAndStatusType();
      }
    })
  }

  submitOnlineClaimSubmission() {
    if (this.isManualSubmission) {
      this.updateSubmissionAndStatusType();
    }
    else {
      const data = this.getClaimSubmissionDocumentData();
      this.groupClaimSubmissionService.addPpoSubmission(data).subscribe(
        res => {
          this.updateSubmissionAndStatusType();
        },
        err => {
          this.messageService.show(err.error.message, "error");
        }
      );
    }
  }

  updateSubmissionAndStatusType() {
    var ppoRequestData = {
      id: this.ppoRequestId,
      isManualSubmission: this.isManualSubmission,
      statusId: this.statusId
    }

    this.ppoListService.updateSubmissionAndStatusType(ppoRequestData).subscribe(
      res => {
        if (this.statusId == PPORequestStatus.Cancelled) {
          this.messageService.show('Successfully cancelled', 'success');
          this.navigationService.toNewCase();
        }
        else {
          this.messageService.show('Successfully submitted', 'success');
          this.navigationService.toPpoRequestList();
        }
      },
      err => {
        this.messageService.show(err.error.message, "error");
      }
    )
  }

  viewDocument(file) {
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, '_blank');
  }

  clearUpload(item) {
    item.file = null;
    this.documentRequiredValidation();
  }

  onBackButtonClick() {
    this.onBackButtonSubmission.emit();
  }

  getPPOClaimFormPdf() {
    var geneateClaimFormVm = {
      ppoRequestId: this.ppoRequestId,
      claimAmount: this.benefitTotalNetAmount
    }

    this.groupClaimSubmissionService.getGmClaimFormDocument().subscribe(res => {
      this.ppoListService.generatePPOClaimForm(geneateClaimFormVm).subscribe(blobResponse => {
        this.fileHandlerService.downloadPdf(blobResponse, 'GM Claim Form.pdf');
        let claimFormFile = new File([blobResponse], "GM Claim Form.pdf", { type: 'application/pdf' });
        this.getClaimFormDocument(claimFormFile, res);
        this.isDownloadPPOClaimForm = false;
      }, err => {
        this.messageService.show(err.error.message, "error");
      });
    });
  }

  getClaimFormDocument(claimFormFile, claimFormData) {
    this.claimForm = {
      documentId: claimFormData.documentId,
      docName: claimFormData.docName,
      file: claimFormFile,
      acctptedTypes: "",
      index: 1,
      isOptional: claimFormData.isOptional
    };
  }

  getPPOBalanceSummaryPdf() {
    this.groupClaimSubmissionService.getGroupItemizedBillDocument().subscribe(res => {
      this.ppoListService.generatePPOBalanceSummary(this.ppoRequestId).subscribe(blobResponse => {
        this.fileHandlerService.downloadPdf(blobResponse, 'PPO Balance Summary.pdf');
        let balanceSummaryFile = new File([blobResponse], "PPO Balance Summary.pdf", { type: 'application/pdf' });
        this.getPPOBalanceSummaryDocument(balanceSummaryFile, res);
        this.isDownloadPPOBalanceSummary = false;
      }, err => {
        this.messageService.show(err.error.message, "error");
      });
    });
  }

  getPPOBalanceSummaryDocument(balanceSummaryFile, groupItemizedBillDocument) {
    this.balanceSummary = {
      documentId: groupItemizedBillDocument.documentId,
      docName: groupItemizedBillDocument.docName,
      file: balanceSummaryFile,
      acctptedTypes: "",
      index: 1,
      isOptional: groupItemizedBillDocument.isOptional
    };
  }

  manualSubmissionClick() {
    if (this.isManualSubmission)
      this.getOnlineClaimSubmissionDocuments();
  }

  isSubmitBtnDisabled() {
    if (!this.isManualSubmission)
      return this.isDocSubmission || this.isDownloadPPOClaimForm || this.isDownloadPPOBalanceSummary;
    else
      return !this.isManualSubmission;
  }
}
